const rankingItems = [
  { rank: 1, title: '鬼灭之刃 柱训练篇', type: '日漫·热血', hot: '🔥 980万热度', change: 'up' },
  { rank: 2, title: '凡人修仙传 第5季', type: '国漫·仙侠', hot: '🔥 860万热度', change: 'up' },
  { rank: 3, title: '葬送的芙莉莲', type: '日漫·奇幻', hot: '🔥 750万热度', change: 'up' },
  { rank: 4, title: '完美世界', type: '国漫·玄幻', hot: '🔥 690万热度', change: 'same' },
  { rank: 5, title: '我推的孩子 第二季', type: '日漫·偶像', hot: '🔥 620万热度', change: 'up' },
  { rank: 6, title: '斗破苍穹 年番', type: '国漫·玄幻', hot: '🔥 580万热度', change: 'down' },
  { rank: 7, title: '迷宫饭', type: '日漫·美食', hot: '🔥 510万热度', change: 'up' },
];

export default function Ranking() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            本周热门榜单
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            根据观看量、讨论度和用户评分综合排名的热门动漫
          </p>
        </div>

        <div className="max-w-3xl mx-auto bg-background-100 rounded-2xl border border-background-200/60 overflow-hidden">
          {rankingItems.map((item, idx) => (
            <div
              key={item.rank}
              className={`flex items-center gap-3 md:gap-4 px-4 md:px-6 py-3.5 md:py-4 transition-colors duration-200 cursor-pointer hover:bg-background-50 ${
                idx < rankingItems.length - 1 ? 'border-b border-background-200/40' : ''
              }`}
            >
              <div
                className={`w-8 h-8 md:w-9 md:h-9 flex items-center justify-center rounded-lg text-sm font-bold shrink-0 ${
                  item.rank === 1
                    ? 'bg-primary-500 text-background-50'
                    : item.rank === 2
                    ? 'bg-accent-500 text-background-50'
                    : item.rank === 3
                    ? 'bg-accent-300 text-accent-900'
                    : 'bg-background-200 text-foreground-500'
                }`}
              >
                {item.rank}
              </div>
              <div className="flex-1 min-w-0">
                <div className="text-sm md:text-base font-semibold text-foreground-900 truncate">{item.title}</div>
                <div className="text-xs text-foreground-500 mt-0.5">{item.type}</div>
              </div>
              <div className="text-xs md:text-sm text-foreground-600 font-medium whitespace-nowrap shrink-0">
                {item.hot}
              </div>
              <div className="w-6 h-6 flex items-center justify-center shrink-0">
                <i
                  className={`text-sm ${
                    item.change === 'up'
                      ? 'ri-arrow-up-line text-primary-500'
                      : item.change === 'down'
                      ? 'ri-arrow-down-line text-foreground-400'
                      : 'ri-subtract-line text-foreground-400'
                  }`}
                ></i>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}